







































































import {Input} from 'element-ui'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {iMaskDirective} from './mixins/imask'

interface EXInput {
  inputSize: any
  inputDisabled: any
  passwordVisible: any
}

/**
 * masking able input
 * todo input cannot validate masked value
 */
@Component({
  directives: {
    imask: iMaskDirective,
  },
})
export default class KInput extends Mixins<Input & EXInput>(Input) {
  @Prop({default: true, type: Boolean}) lazy: boolean
  @Prop({default: null}) mask: any
  @Prop({default: null, type: String}) inputClass: string | null

  get imask() {
    const {mask, lazy} = this
    if(!mask) {
      return false
    }
    return {mask, lazy}
  }

  get inputType() {
    const {showPassword, passwordVisible, type} = this
    if(showPassword) {
      if(passwordVisible) {
        return 'text'
      }
      return 'password'

    }
    return type
  }

  get classes() {
    const {
      type, inputSize, inputDisabled,
      $slots, prefixIcon, suffixIcon,
      clearable, showPassword,
    } = this
    const result: { [key: string]: any } = {}
    if(type === 'textarea') {
      result['el-textarea'] = true
    } else {
      result['el-input'] = true
    }
    if(inputSize) {
      result[`el-input--${inputSize}`] = true
    }
    result['is-disabled'] = inputDisabled
    result['el-input-group'] = $slots.prepend || $slots.append
    result['el-input-group--append'] = $slots.append
    result['el-input-group--prepend'] = $slots.prepend
    result['el-input--prefix'] = $slots.prefix || prefixIcon
    result['el-input--suffix'] = $slots.suffix || suffixIcon || clearable || showPassword
    return result
  }

  onChange() {
    // empty
  }

  onBlur() {
    this.$emit('blur')
  }

  onFocus(event) {
    this.$emit('focus', event)
  }

  onComplete(event, ...args) {
    this.$emit('complete', ...args)
  }

  onAccept(event, ...args) {
    this.$emit('accept', ...args)
    this.$emit('unmasked-input', event.detail.unmaskedValue)
    this.$emit('input', event.detail.value)
  }
}
